import React from 'react';
import Flatpickr from 'react-flatpickr';
import FlatpickrLanguages from 'flatpickr/dist/l10n';
import 'flatpickr/dist/themes/material_blue.css';
/**
 * 派工日曆 - 日期選擇
 * @module @/modules/dispatch-calendar/components/DatePicker
 */
export default function DatePicker({
  id = '',
  value = '',
  disabled = false,
  onClose = ([date]) => {},
  error = null,
}) {
  const datePickerOptions = {
    enableTime: true,
    minuteIncrement: 30,
    dateFormat: 'Y-m-d H:i',
    time_24hr: true,
    locale: {
      ...FlatpickrLanguages['zh_tw'],
      firstDayOfWeek: 1,
    },
    onDayCreate: (dObj, dStr, fp, dayElem) => {
      const day = dayElem.dateObj.getDay();
      if (day === 0 || day === 6) {
        dayElem.style.color = '#4848484D';
      }
    },
  };

  return (
    <Flatpickr
      id={id}
      className={`form-control ${error ? 'is-invalid' : ''}`}
      value={value}
      onClose={onClose}
      options={datePickerOptions}
      disabled={disabled}
    />
  );
}
